import Terms from "../layout/Terms/Terms";
function TermsPage() {
  return <Terms />;
}

export default TermsPage;
